import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'automations/store';

const baseSelector = (state: RootState) => state.automations.automationList;

export const sortOptionsSelector = createSelector(
  baseSelector,
  (automationList) => automationList.sortOptions,
);

export const filterOptionsSelector = createSelector(
  baseSelector,
  (automationList) => automationList.filterOptions,
);

export const filterOptionsForQuerySelector = createSelector(
  filterOptionsSelector,
  (filterOptions) => Object.fromEntries(
    Object.entries(filterOptions ?? {}).filter(([, value]) => value !== 'any'),
  ),
);
